// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cacheKey: __t.string().primaryKey().name("cache_key"),
  provider: __t.string(),
  model: __t.string(),
  voice: __t.string(),
  textPreview: __t.string().name("text_preview"),
  mimeType: __t.string().name("mime_type"),
  sampleRate: __t.u32().name("sample_rate"),
  audioBytes: __t.byteArray().name("audio_bytes"),
  durationMs: __t.u32().name("duration_ms"),
  createdAt: __t.timestamp().name("created_at"),
  lastUsedAt: __t.timestamp().name("last_used_at"),
  hitCount: __t.u64().name("hit_count"),
  blobPath: __t.option(__t.string()).name("blob_path"),
});
